import { createContext, useContext } from 'react';

import { EntityGridConstraints } from '.';

const EntityGridConstraintsContext =
  createContext<EntityGridConstraints | null>(null);

export const EntityGridConstrainsProvider =
  EntityGridConstraintsContext.Provider;
export const useEntityGridConstraints = () => {
  const constraints = useContext(EntityGridConstraintsContext);
  if (!constraints) {
    throw new Error(
      'useEntityGridConstraints must be used within an EntityGridConstrainsProvider',
    );
  }
  return constraints;
};
